var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dialer-settings-main"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-3 calc-title-widthIOS v2"
  }, [_c('div', {
    staticClass: "settingsTextAndIconOnTop",
    on: {
      "click": function ($event) {
        return _vm.$emit('back');
      }
    }
  }, [_c('vb-icon', {
    attrs: {
      "icon": "backToSettingsList-IOSIcon",
      "width": "11.434",
      "height": "20"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('back');
      }
    }
  }), _c('div', {
    staticClass: "settingsTextOnTop"
  }, [_vm._v("Settings")])], 1), _c('div', {
    staticClass: "dialer-settings-title topMainHeading"
  }, [_vm._v("Users")]), _c('div', {
    staticClass: "plus-IOSIcon-container"
  }, [_c('vb-icon', {
    staticClass: "plus-IOSIcon",
    attrs: {
      "icon": "plus-IOSIcon",
      "width": "20",
      "height": "19.992"
    },
    on: {
      "click": function ($event) {
        return _vm.$modal.show('AddUserANDSubUser');
      }
    }
  })], 1)]), _c('section', {
    staticClass: "dialer-settings-section dialer-users-setting"
  }, [[_c('div', {
    staticClass: "mobileInputIOS iconOnLeft mt-32px"
  }, [_c('b-input', {
    attrs: {
      "type": "text",
      "placeholder": "Search user"
    },
    model: {
      value: _vm.filter.list.search,
      callback: function ($$v) {
        _vm.$set(_vm.filter.list, "search", $$v);
      },
      expression: "filter.list.search"
    }
  }), _c('vb-icon', {
    staticClass: "mobileInputIOS-icon",
    attrs: {
      "width": "13.785",
      "height": "13.726",
      "icon": "Search-IOSIcon"
    }
  })], 1)], _c('div', {
    staticClass: "basicWhiteIOScard mt-32px mb-16px"
  }, _vm._l(_vm.filterList, function (data) {
    return _c('div', {
      key: data.id || data.voipaccount,
      staticClass: "basicWhiteIOScard-item",
      on: {
        "click": function ($event) {
          !data.voipaccount || data.active_status != '1' || _vm.api.delete_user.send ? '' : _vm.$modal.show('EditUser', {
            account: data.voipaccount
          });
        }
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      staticClass: "InfoComponentInsideAnroidIOSApp"
    }, [_c('vb-avatar', {
      attrs: {
        "id": data.voipaccount,
        "is_blf": false
      }
    })], 1), _c('div', {
      staticClass: "d-flex flex-column"
    }, [!data.voipaccount ? [_c('div', {
      staticClass: "textInsideCard"
    }, [_vm._v(" " + _vm._s(data.email) + " ")])] : [_c('div', {
      staticClass: "headingInsideTable"
    }, [_vm._v(" " + _vm._s(_vm._f("get_property")(data, 'user.display_name')) + " ")])]], 2)]), _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      staticClass: "d-flex flex-column mr-6px"
    }, [data.voipaccount ? _c('div', {
      staticClass: "textInsideCard textAlignRight onRightSide"
    }, [_vm._v(" " + _vm._s(["1", "3", 1].indexOf(data.user.userRole) >= 0 ? "Admin" : "User") + " ")]) : _c('div', {
      staticClass: "textInsideCard textAlignRight onRightSide"
    }, [_vm._v(" " + _vm._s(_vm._f("invitaionText")(data)) + " "), _c('span', [_vm._v("- " + _vm._s(_vm._f("filter_date_current")(data.expire_time * 1000)))])])]), _c('vb-icon', {
      staticClass: "rightFacingArrow",
      attrs: {
        "icon": "rightFacingArrow-IOSIcon",
        "width": "16.642",
        "height": "15.275"
      }
    })], 1)]);
  }), 0), _vm.filterList.length == 0 ? _c('vb-no-record', {
    attrs: {
      "text": 'There is no Users',
      "design": 3
    }
  }) : _vm._e(), _c('EditUserModal', {
    on: {
      "update-list": function ($event) {
        return _vm.afterAdding();
      }
    }
  }), _c('AddUserAndSubUserModal', {
    on: {
      "user-added": function ($event) {
        return _vm.afterAdding();
      }
    }
  })], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }